import './pageTitle.scss'
import templateUrl from './pageTitle.html'

/**
 * Component for page title.
 *
 * @example <caption>Label of the current state as title</caption>
 *     <tmr-page-title></tmr-page-title>
 *
 * @example <caption>Custom title</caption>
 *     <tmr-page-title title="TITLE.TRANSLATION.KEY"></tmr-page-title>
 *
 * @example <caption>Breadcrumbs (for breadcrumbs format, @see tmrBreadcrumbs directive)</caption>
 *     <tmr-page-title breadcrumbs="[...]"></tmr-page-title>
 *
 * @example <caption>Custom page actions (shown on the right of the toolbar)</caption>
 *     <tmr-page-title>
 *       <tmr-page-actions>Any content here...</tmr-page-actions>
 *     </tmr-page-title>
 *
 * @type {ngComponent}
 */
export const tmrPageTitle = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrPageTitleController',
  bindings: {
    breadcrumbs: '<',
    title: '<',
  },
  transclude: {
    actions: '?tmrPageActions',
  },
}

/**
 * Controller of component {@link tmrPageTitle}.
 *
 * @type {ngController}
 */
export class tmrPageTitleController {
  static ngType = 'controller'

  constructor($state, tmrDemo) {
    'ngInject'
    Object.assign(this, { $state, tmrDemo, env: process.env.env })
  }

  $onInit() {
    // If title was not passed, use the label of the current state.
    this.title = this.title ?? this.$state.current.label
    // If breadcrumbs were not passed, use the title.
    this.breadcrumbs = this.breadcrumbs ?? [{ translate: this.title }]
  }
}
